// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f8f9fa;
}
.spinner {
  width: 64px;
  height: 64px;
  border: 4px solid #3498db;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.loading-text {
  margin-left: 10px;
  font-size: 1.2rem;
  font-weight: bold;
  color: #555;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/loading_page/index.less"],"names":[],"mappings":"AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,yBAAA;AAHF;AAMA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AAJF;AAOA;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AALF;AAQA;EACE;IAAK,uBAAA;EALL;EAMA;IAAO,yBAAA;EAHP;AACF","sourcesContent":["@primary-color: #3498db;\n@spinner-size: 64px;\n@border-width: 4px;\n\n.loading-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  background-color: #f8f9fa;\n}\n\n.spinner {\n  width: @spinner-size;\n  height: @spinner-size;\n  border: @border-width solid @primary-color;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.loading-text {\n  margin-left: 10px;\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #555;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
